export default "__VITE_PUBLIC_ASSET__90fac202__"